// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__YWTzw","primary":"Button_primary__2CVjg","secondary":"Button_secondary__3z7NZ"};